// eslint-disable-next-line import/prefer-default-export
var EVENT_TYPE_PAGELOAD = 'pageLoad';export{EVENT_TYPE_PAGELOAD};